import { Pipeline } from '@/types';

import { favoriteService } from './favorites';
import { toPipelineCreateInput, toPipelineUpdateInput } from './resourceMutationPayloads';
import { createSanitizedResourceService } from './resources';

const base = createSanitizedResourceService<
    Pipeline,
    ReturnType<typeof toPipelineCreateInput>,
    ReturnType<typeof toPipelineUpdateInput>
>('/api/pipelines', toPipelineCreateInput, toPipelineUpdateInput);

export const pipelineService = {
    ...base,
    setArchived: (id: string, isArchived: boolean) => base.update(id, { isArchived }),
    setFavorite: (id: string, isFavorite: boolean) => favoriteService.set<Pipeline>('pipelines', id, isFavorite),
    setLocked: (id: string, isLocked: boolean) => base.update(id, { isLocked }),
};
